/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreProfileImageMetaData
 */
export interface StoreProfileImageMetaData {
    /**
     * 
     * @type {string}
     * @memberof StoreProfileImageMetaData
     */
    imageKey: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileImageMetaData
     */
    filename: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfileImageMetaData
     */
    contentType: string;
}

/**
 * Check if a given object implements the StoreProfileImageMetaData interface.
 */
export function instanceOfStoreProfileImageMetaData(value: object): value is StoreProfileImageMetaData {
    if (!('imageKey' in value) || value['imageKey'] === undefined) return false;
    if (!('filename' in value) || value['filename'] === undefined) return false;
    if (!('contentType' in value) || value['contentType'] === undefined) return false;
    return true;
}

export function StoreProfileImageMetaDataFromJSON(json: any): StoreProfileImageMetaData {
    return StoreProfileImageMetaDataFromJSONTyped(json, false);
}

export function StoreProfileImageMetaDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfileImageMetaData {
    if (json == null) {
        return json;
    }
    return {
        
        'imageKey': json['imageKey'],
        'filename': json['filename'],
        'contentType': json['contentType'],
    };
}

export function StoreProfileImageMetaDataToJSON(json: any): StoreProfileImageMetaData {
    return StoreProfileImageMetaDataToJSONTyped(json, false);
}

export function StoreProfileImageMetaDataToJSONTyped(value?: StoreProfileImageMetaData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'imageKey': value['imageKey'],
        'filename': value['filename'],
        'contentType': value['contentType'],
    };
}

